import React from "react";
import navIcons from "../Assets/Icons/index";

export const overviewList = [
  {
    title: "Stage",
    key: "stage",
    icon: <navIcons.IconStatus fill="#16191f" height="26px" width="22px" />,
  },
  // {
  //   title: "Outcome",
  //   key: "outcome",
  //   icon: <navIcons.IconStatus fill="#16191f" height="26px" width="22px" />,
  // },
];

export const countKeys = [
  "all_count",
  "prospecting_count",
  "first_contact_count",
  "viewing_count",
  "viewing_outcome_count",
  "assessment_count",
  "assessment_outcome_count",
  "closed_count",
];

export const enquiryListFilter = [
  { count: "all_count", label: "All" },
  { count: "prospecting_count", label: "Prospecting" },
  { count: "first_contact_count", label: "First Contact" },
  { count: "viewing_count", label: "Viewing" },
  { count: "viewing_outcome_count", label: "Viewing Outcome" },
  { count: "assessment_count", label: "Assessment" },
  { count: "assessment_outcome_count", label: "Assessment Outcome" },
  { count: "closed_count", label: "Closed" },
];

export const enquiryStats = [
  {
    title: "Prospecting",
    value: 15,
    color: "#C5E3FF",
    key: "prospecting_count",
  },
  {
    title: "First Contact",
    value: 15,
    color: "#C5E3FF",
    key: "first_contact_count",
  },
  { title: "Viewing", value: 35, color: "#ffe8c5", key: "viewing_count" },
  {
    title: "Viewing Outcome",
    value: 35,
    color: "#FFB800",
    key: "viewing_outcome_count",
  },
  {
    title: "Assessment",
    value: 10,
    color: "#70BB63",
    key: "assessment_count",
  },
  {
    title: "Assessment Outcome",
    value: 10,
    color: "#70BB63",
    key: "assessment_outcome_count",
  },
  { title: "Closed", value: 15, color: "#C4C4C4", key: "closed_count" },
];

export const enquiryColorCode = {
  Prospecting: {
    bg: "#C5E3FF",
    color: "#fff",
  },
  FirstContact: {
    bg: "#9CD0FF",
  },
  Viewing: {
    bg: "#f5d6b6",
  },
  ViewingOutcome: {
    bg: "#FFB800",
  },
  Assessment: {
    bg: "#a9d7bb",
  },
  AssessmentOutcome: {
    bg: "#70BB63",
  },
  Closed: {
    bg: "#C4C4C4",
  },
};

export const ScheduleColorCode = {
  Reminder: "#ffc5c9",
  Call: "#ffc5c9",
  Viewing: "#f5d6b6",
  Assessment: "#a9d7bb",
};
export const assessmentStatus = ["Accepted", "Declined"];

export const outcomeChip = {
  Not: "light",
  Accepted: "success",
  Declined: "warn",
};
export const outcomeTypes = [
  "First Contact",
  "Viewing Outcome",
  "Assessment Outcome",
];

export const outcomeCommentList = [
  "First Contact",
  "Viewing Outcome",
  "Assessment Outcome",
];

export const outcomeStatusList = ["Assessment Outcome"];

export const closeStatusList = ["Won", "Close", "No Outcome"];

export const referrerTypes = [
  "Digital",
  "Recommendation",
  "Local Reputation",
  "Advertising",
];

export const refererList = {
  Digital: [
    "Google business",
    "Bing places",
    "TrustedCare.co.uk",
    "Own website",
    "Other digital",
    "NHS choices",
    "Carehome.co.uk",
    "Care Choices",
    "Findacare.co.uk",
    "Facebook",
  ],
  Recommendation: [
    "Solicitor",
    "Social worker",
    "Friend / Family of resident",
    "Continuing health",
    "Other recommendation",
    "GP / District nurses",
    "Discharge team",
    "Brokerage",
  ],
  LocalReputation: ["Home known locally", "Other local reputation"],
  Advertising: [
    "Local Magazine/Newspaper",
    "Other Advertising",
    "Local door drop",
    "Event advertising",
  ],
};

export const outcomeHelperText = {
  Accepted: `This will close enquiry and mark as ‘Won’`,
  Declined: `This will close enquiry and mark as ‘Lost’`,
};

export const enquiryKeys = [
  "care_seeker_title",
  "care_seeker_first_name",
  "care_seeker_last_name",
  "title",
  "first_name",
  "last_name",
  "email",
  "phone",
  "stage",
  "date_of_birth",
  "location_id",
  "outcome",
  "assigned_user_type",
  "assigned_user",
  "whos_need_care",
  "soon_care_need",
  "type_of_funding",
  "type_of_care",
  "length_of_stay",
  "period_of_respite",
  //
  "address_1",
  "address_2",
  "city",
  "postcode",
  "country",
  "county",
  //
  "message",
  "medical_condition",
  "name_of_social_worker",
  //
  "has_attorney",
  "attorney_name",
  "located",
  //
  "status",
  "planned_admission_date",
  "agreed_fees",
  "admission_comment",
  "assessment_declined_comment",
  "name_of_person",
  //
  "stage_user_type",
  "stage_user",
  "stage_date",
  "stage_comment",
  //
  "source",
  "prone_to_wander",
  "challenging_behaviour",
  "gender",
  //
  "close_status",
  "close_reason",
  "room_no",
  "residency_type",
  "end_date_of_respite",
  "referrer_type",
  "referer",
  "power_of_attroney",
  "has_dementia",
  "network_id",
  "type",
  //
  "name_of_local_authority",
  "la_funding_percentage",
  //
  "PER_no",
  "care_priority",
  "referred_date_from_brokerage",
];

export const ClosedCodes = {
  Admitted: "success",
  Declined: "warn",
  NoOutcome: "light",
};

export const CloseReasonList = [`Admitted`, `Declined`, `No Outcome`];

export const ReportFilterList = [
  {
    label: `Last 7 days`,
    key: "last_week",
  },
  {
    label: `Current month`,
    key: "current_month",
  },
  {
    label: `Year to date`,
    key: "year_to_date",
  },
  // {
  //   label: `Custom`,
  //   key: "custom",
  // },
];

export const LocalAuthName = [
  `Local Authority`,
  `Local Authority with Top Up`,
  `NHS Continuing Healthcare (CHC)`,
];
export const LocalAuthPer = [`Local Authority with Top Up`];

export const LocalTypes = [`Local Authority`, `Local Authority with Top Up`];
